import * as React from 'react';

import { Label, IBoxComponentProps, Text, variables, Skeleton } from '@moosend/mooskin';

export const StepTitle: React.FC<{ children: string | JSX.Element } & IBoxComponentProps> = (props) => {
	return <Label mb={30} minW="unset" fontSize={18} fontColor="fontColors.primary2" fontWeight={500} {...props} />;
};

StepTitle.displayName = 'StepTitle';

export const SecondaryStepTitle: React.FC<{ children: string | JSX.Element } & IBoxComponentProps> = (props) => {
	return <Label mb={20} minW="unset" fontSize={[14, 14, 16, 16]} fontColor="fontColors.primary2" fontWeight="bold" {...props} />;
};

SecondaryStepTitle.displayName = 'SecondaryStepTitle';

export const WizardTitle: React.FC<{ children: string | JSX.Element; isLoading?: boolean } & IBoxComponentProps> = (props) => {
	return (
		<Text px={[30, 30, 10, 10]} fontWeight={500} fontSize={29} pb={60}>
			{/* <Skeleton isLoaded={!props.isLoading}>{props.children}</Skeleton> */}
			{props.children}
		</Text>
	);
};

WizardTitle.displayName = 'WizardTitle';
